import hook from '../../scripts/utilities/hook';

const SELECTBOX_SELECTOR = hook('js-selectbox');
const HEAD_SELECTOR = hook('js-selectbox-head');
const CURRENT_SELECTOR = hook('js-selectbox-current');
const LIST_SELECTOR = hook('js-selectbox-list');

const ACTIVE_CLASS = 'is-open';
const OPENED_STATE = 'OPENED';
const CLOSED_STATE = 'CLOSED';
let CURRENT_STATE = CLOSED_STATE;

class SELECTBOX {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }

    this.element = element;

    this.initSelector();
    this.initListeners();
  }

  initSelector() {
    this.head = this.element.querySelector(HEAD_SELECTOR);
    this.current = this.element.querySelector(CURRENT_SELECTOR);
    this.list = this.element.querySelector(LIST_SELECTOR);
    this.listItems = this.list.children;
  }

  initListeners() {
    this.createNativeSelect();
    this.head.addEventListener(
      'click',
      event => {
        this.toggleSelectbox(event);
      },
      {
        capture: false,
      },
    );
    [...this.listItems].forEach((listItem, index) => {
      listItem.addEventListener(
        'click',
        event => {
          this.updateOption(event, index);
        },
        {
          capture: false,
        },
      );
    });
  }

  createNativeSelect() {
    const newSelect = document.createElement('select');

    if (this.element.dataset.selectboxId) {
      newSelect.id = this.element.dataset.selectboxId;
    }

    if (this.element.dataset.selectboxName) {
      newSelect.name = this.element.dataset.selectboxName;
    }

    this.element.appendChild(newSelect);

    [...this.listItems].forEach(listItem => {
      const newOption = document.createElement('option');
      newOption.value = listItem.getAttribute('value');
      newOption.text = listItem.innerText;
      newSelect.appendChild(newOption);
    });
  }

  updateNativeSelectedOption(selectedIndex) {
    const select = this.element.querySelector('select');

    select.selectedIndex = selectedIndex;
  }

  // eslint-disable-next-line class-methods-use-this
  getCurrentData(currentTarget) {
    const currentData = currentTarget.innerHTML;

    return currentData;
  }

  // eslint-disable-next-line class-methods-use-this
  getCurrentValue(currentTarget) {
    const currentValue = currentTarget.getAttribute('value');

    return currentValue;
  }

  updateData(currentTarget) {
    const currentData = this.getCurrentData(currentTarget);

    this.current.innerHTML = currentData;
  }

  updateValue(currentTarget) {
    const currentData = this.getCurrentValue(currentTarget);
    this.current.setAttribute('value', currentData);
  }

  updateOption(event, index) {
    const { currentTarget } = event;

    this.updateData(currentTarget);
    this.updateValue(currentTarget);
    this.updateNativeSelectedOption(index);
  }

  openSelectbox() {
    this.element.classList.add(ACTIVE_CLASS);

    document.addEventListener(
      'click',
      documentEvent => {
        this.bindClickEventOutsideSelectbox(documentEvent);
      },
      {
        once: true,
        capture: false,
      },
    );
  }

  closeSelectbox() {
    this.element.classList.remove(ACTIVE_CLASS);
  }

  bindClickEventOutsideSelectbox(event) {
    this.toggleSelectbox(event);

    document.removeEventListener('click', this.bindClickEventOutsideSelectbox);
  }

  toggleSelectbox(event) {
    event.stopPropagation();
    if (CURRENT_STATE === CLOSED_STATE) {
      CURRENT_STATE = OPENED_STATE;

      this.openSelectbox();
    } else if (
      CURRENT_STATE === OPENED_STATE &&
      this.list !== event.target &&
      !this.list.contains(event.target)
    ) {
      CURRENT_STATE = CLOSED_STATE;

      this.closeSelectbox();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(SELECTBOX_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new SELECTBOX(element);
  });
});
